/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Followers_DescInputs */

const en_story_followers_desc = /** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only approved followers see this`)
};

const es_story_followers_desc = /** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo los seguidores aprobados ven esto`)
};

const fr_story_followers_desc = /** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuls les abonnés approuvés voient ceci`)
};

const de_story_followers_desc = /** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur zugelassene Follower sehen dies`)
};

const id_story_followers_desc = /** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya pengikut yang disetujui yang melihat ini`)
};

/** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */
const ja_story_followers_desc = en_story_followers_desc;

/** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */
const zh_story_followers_desc = en_story_followers_desc;

/** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */
const ar_story_followers_desc = en_story_followers_desc;

/** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */
const it_story_followers_desc = en_story_followers_desc;

/** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */
const ru_story_followers_desc = en_story_followers_desc;

/** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */
const pt_story_followers_desc = en_story_followers_desc;

/** @type {(inputs: Story_Followers_DescInputs) => LocalizedString} */
const ko_story_followers_desc = en_story_followers_desc;

/**
* | output |
* | --- |
* | "Only approved followers see this" |
*
* @param {Story_Followers_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_followers_desc = /** @type {((inputs?: Story_Followers_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Followers_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_followers_desc(inputs)
	if (locale === "es") return es_story_followers_desc(inputs)
	if (locale === "fr") return fr_story_followers_desc(inputs)
	if (locale === "de") return de_story_followers_desc(inputs)
	if (locale === "ja") return ja_story_followers_desc(inputs)
	if (locale === "zh") return zh_story_followers_desc(inputs)
	if (locale === "ar") return ar_story_followers_desc(inputs)
	if (locale === "id") return id_story_followers_desc(inputs)
	if (locale === "it") return it_story_followers_desc(inputs)
	if (locale === "ru") return ru_story_followers_desc(inputs)
	if (locale === "pt") return pt_story_followers_desc(inputs)
	return ko_story_followers_desc(inputs)
});